export default "__VITE_ASSET__5MSxlC9B__"